<template>
  <div class="college-menu">
    <table-list
      title="菜单列表"
      :loading="loading"
      :data="list"
      :columns="columns(this)"
      :operates="operates(this)"
      :btns="btns(this)"
      row-key="menuId"
      :options="{ selection: true, operatesWidth: 140 }"
      :pager="pager"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="名称" prop="menuName">
          <el-input v-model="form.menuName" style="width:300px" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="上级菜单" prop="parentId">
          <el-select
            v-model="form.parentId"
            style="width:300px"
            placeholder="选择上级菜单"
            clearable
          >
            <el-option
              v-for="(item, index) in systemMenuList"
              :key="index"
              :label="item.menuName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接" prop="url">
          <el-input v-model="form.url" style="width:300px" placeholder="请输入链接"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            v-model.number="form.sort"
            style="width:300px"
            placeholder="请输入排序"
          ></el-input>
        </el-form-item>
        <el-form-item label="菜单图标" prop="icon">
          <el-select v-model="form.icon" style="width:300px" placeholder="选择菜单图标" clearable>
            <i v-if="form.icon" slot="prefix" :class="form.icon" style="margin-left:5px"></i>
            <el-option
              v-for="(item, index) in iconList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
              <i :class="item.value" style="margin-right: 8px;"></i>
              <span>{{ item.label }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const validateSort = (rule, value, callback) => {
  if (value === '' || value === null || value === undefined) {
    return callback(new Error('请输入排序'))
  }
  const num = Number(value)
  if (!Number.isInteger(num)) {
    return callback(new Error('排序必须为整数'))
  }
  if (num < 0) {
    return callback(new Error('排序必须大于或等于0'))
  }
  callback()
}

const btns = _this => [
  {
    label: '新增菜单',
    type: 'primary',
    method: _this.handleAdd,
  },
  {
    label: '删除',
    type: 'danger',
    method: _this.handleBatchDelete,
  },
]

const columns = _this => [
  {
    prop: 'id',
    label: '编号',
    minWidth: '80px',
  },
  {
    prop: 'menuName',
    label: '名称',
    minWidth: '140px',
  },
  {
    prop: 'parentId',
    label: '上级编号',
    minWidth: '90px',
  },
  {
    prop: 'parentName',
    label: '上级名称',
    minWidth: '120px',
  },
  {
    prop: 'path',
    label: '链接',
    minWidth: '220px',
  },
  {
    prop: 'sort',
    label: '排序',
    minWidth: '70px',
  },
  {
    label: '可用状态',
    minWidth: '90px',
    render: (h, { row }) => {
      return [
        h('el-switch', {
          props: { value: row.status, activeValue: 0, inactiveValue: 1 },
          on: {
            change: v => {
              _this.handleStatusChange(v, row)
            },
          },
        }),
      ]
    },
  },
  {
    prop: 'createTime',
    label: '添加时间',
    minWidth: '160px',
  },
]

const operates = _this => [
  {
    label: '编辑',
    method: _this.handleEdit,
  },
  {
    label: '删除',
    method: _this.handleDelete,
    color: '#f56c6c',
  },
]

import TableList from '@/components/TableList'
import {
  menuList,
  systemMenuStatusUpdate,
  menuListBatchDelete,
  systemMenuFilter,
  menuListCreate,
  menuListUpdate,
} from '@/api/system'
import to from 'await-to'

export default {
  name: 'CollegeMenu',
  components: {
    TableList,
  },
  data() {
    return {
      btns,
      columns,
      operates,
      loading: false,
      list: [],
      selectItems: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      dialogVisible: false,
      dialogTitle: '新增菜单',
      submitting: false,
      form: {
        menuName: '',
        parentId: '',
        url: '',
        sort: '',
        icon: '',
      },
      rules: {
        menuName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        // parentId: [{ required: true, message: '请选择上级菜单', trigger: 'change' }],
        url: [{ required: true, message: '请输入链接', trigger: 'blur' }],
        sort: [{ required: true, validator: validateSort, trigger: 'blur' }],
        // icon: [{ required: true, message: '请选择菜单图标', trigger: 'change' }],
      },
      systemMenuList: [],
      iconList: [
        { label: '首页', value: 'el-icon-s-home' },
        { label: '数据', value: 'el-icon-s-data' },
        { label: '菜单', value: 'el-icon-menu' },
        { label: '文件', value: 'el-icon-document' },
        { label: '文件组', value: 'el-icon-files' },
        { label: '用户', value: 'el-icon-user' },
        { label: '用户组', value: 'el-icon-user-solid' },
        { label: '设置', value: 'el-icon-setting' },
        { label: '平台', value: 'el-icon-s-platform' },
        { label: '订单', value: 'el-icon-s-order' },
        { label: '工具', value: 'el-icon-s-tools' },
        { label: '金币', value: 'el-icon-coin' },
        { label: '消息', value: 'el-icon-message' },
        { label: '邮件', value: 'el-icon-message-solid' },
        { label: '警告', value: 'el-icon-warning' },
        { label: '问号', value: 'el-icon-question' },
        { label: '编辑', value: 'el-icon-edit' },
        { label: '删除', value: 'el-icon-delete' },
        { label: '搜索', value: 'el-icon-search' },
        { label: '分享', value: 'el-icon-share' },
        { label: '收藏', value: 'el-icon-star-on' },
        { label: '图片', value: 'el-icon-picture' },
        { label: '视频', value: 'el-icon-video-camera' },
        { label: '日历', value: 'el-icon-date' },
        { label: '时间', value: 'el-icon-time' },
        { label: '位置', value: 'el-icon-location' },
        { label: '全屏', value: 'el-icon-full-screen' },
        { label: '上传', value: 'el-icon-upload' },
        { label: '下载', value: 'el-icon-download' },
        { label: '刷新', value: 'el-icon-refresh' },
      ],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(
        menuList({ current, size, clientCode: '0a983d86-2527-5512-01a9-783cd0e1' }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.pager.total = res.data.total
      this.list = res.data.list
    },
    onSearch() {
      this.pager.current = 1
      this.getList()
    },
    handleSelectionChange(val) {
      this.selectItems = val
    },
    resetForm() {
      this.form = {
        menuName: '',
        parentId: '',
        url: '',
        sort: '',
        icon: '',
      }
    },
    handleAdd() {
      this.handleGetSystemMenu()
      this.resetForm()
      this.dialogTitle = '新增菜单'
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    async handleGetSystemMenu() {
      const [res, err] = await to(
        systemMenuFilter({ clientCode: '0a983d86-2527-5512-01a9-783cd0e1' }),
      )
      if (err) return this.$message.warning(err.msg)
      this.systemMenuList = res.data
    },
    handleEdit(row) {
      this.handleGetSystemMenu()
      this.form = { ...row }
      this.$set(this.form, 'url', row.path)
      if (row.parentId === 0) {
        this.$set(this.form, 'parentId', '')
      }
      this.dialogTitle = '编辑菜单'
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        if (!this.form.id) {
          this.submitting = true
          const [, err] = await to(
            menuListCreate({ ...this.form, clientCode: '0a983d86-2527-5512-01a9-783cd0e1' }),
          )
          this.submitting = false
          if (err) return this.$message.warning(err.msg)
          this.$message.success('创建成功')
          this.resetForm()
          this.dialogVisible = false
          window.location.reload()
        } else {
          this.submitting = true
          const [, err] = await to(
            menuListUpdate({
              ...this.form,
              menuId: this.form.id,
              clientCode: '0a983d86-2527-5512-01a9-783cd0e1',
            }),
          )
          this.submitting = false
          if (err) return this.$message.warning(err.msg)
          this.$message.success('编辑成功')
          this.resetForm()
          this.dialogVisible = false
          window.location.reload()
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该菜单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(
            menuListBatchDelete({
              menuIds: [row.id],
              clientCode: '0a983d86-2527-5512-01a9-783cd0e1',
            }),
          )
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          // this.getList()
          window.location.reload()
        })
        .catch(() => {})
    },
    handleBatchDelete() {
      if (!this.selectItems.length) return this.$message.warning('请先选择要删除的菜单')
      const menuIds = this.selectItems.map(item => item.id)
      this.$confirm('确认删除选中的菜单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(
            menuListBatchDelete({ menuIds, clientCode: '0a983d86-2527-5512-01a9-783cd0e1' }),
          )
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          this.getList()
        })
        .catch(() => {})
    },
    async handleStatusChange(v, row) {
      const [, err] = await to(
        systemMenuStatusUpdate({
          menuId: row.id,
          status: v,
          clientCode: '0a983d86-2527-5512-01a9-783cd0e1',
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('状态更新成功')
      this.getList()
    },
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.college-menu {
  .dialog-footer {
    text-align: right;
  }
}
</style>
